import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import KeywordDeletionFromDocumentEditing from './keyworddeletionfromdocumentediting';

export default class KeywordDeletionFromDocument extends Plugin {
  static get requires() {
    return [KeywordDeletionFromDocumentEditing];
  }

  static get pluginName() {
    return 'KeywordDeletionFromDocument';
  }
}
